var React = require('react');

function ArrowTextlink (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.15375 3.64652L8.8002 3.29297L8.09309 4.00008L8.44664 4.35363L11.5925 7.49949H3.2002H2.7002V8.49949H3.2002H11.5937L8.44664 11.6465L8.09309 12.0001L8.8002 12.7072L9.15375 12.3536L13.1537 8.35363C13.349 8.15837 13.349 7.84178 13.1537 7.64652L9.15375 3.64652Z","fill":"#007A73","className":"arrow"}));
}

ArrowTextlink.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowTextlink;

ArrowTextlink.default = ArrowTextlink;
